<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Contents">Contents</h2>
<p class="firstverse"><a href="#/Text/Foreword">Foreword by John Witte Jr.</a></p>
<p class="firstverse"><a href="#/Text/Introduction">Introduction</a></p>
<p class="firstverse"><a href="#/Text/Chapter1">1: The Biblical Foundations of Law</a></p>
<p class="verse2">Creation, Fall and the Patriarchs</p>
<p class="verse2"><em class="i">Randy Beck and David VanDrunen</em></p>
<p class="firstverse"><span href="#/Text/Chapter2" title="Link target outside of Sample">2: Law and Political Order</span></p>
<p class="verse2">Israel’s Constitutional History</p>
<p class="verse2"><em class="i">William S. Brewbaker III and V. Philips Long</em></p>
<p class="firstverse"><span href="#/Text/Chapter3" title="Link target outside of Sample">3: Criminal and Civil Law in the Torah</span></p>
<p class="verse2">The Mosaic Law in Christian Perspective</p>
<p class="verse2"><em class="i">David Skeel and Tremper Longman III</em></p>
<p class="firstverse"><span href="#/Text/Chapter4" title="Link target outside of Sample">4: The Law of Life</span></p>
<p class="verse2">Law in the Wisdom Literature</p>
<p class="verse2"><em class="i">Roger P. Alford and Leslie M. Alford</em></p>
<p class="firstverse"><span href="#/Text/Chapter5" title="Link target outside of Sample">5: Crying Out for Justice</span></p>
<p class="verse2">Civil Law and the Prophets</p>
<p class="verse2"><em class="i">Barbara E. Armacost and Peter Enns</em></p>
<p class="firstverse"><span href="#/Text/Chapter6" title="Link target outside of Sample">6: The Kingdom of God, Law, and the Heart</span></p>
<p class="verse2">Jesus and the Civil Law</p>
<p class="verse2"><em class="i">Robert F. Cochran Jr. and Dallas Willard</em></p>
<p class="firstverse"><span href="#/Text/Chapter7" title="Link target outside of Sample">7: Civil Law and Civil Disobedience</span></p>
<p class="verse2">The Early Church and the Law</p>
<p class="verse2"><em class="i">Joel A. Nichols and James W. McCarty III</em></p>
<p class="firstverse"><span href="#/Text/Chapter8" title="Link target outside of Sample">8: Living as Christians Under Civil Law</span></p>
<p class="verse2">The New Testament Letters, Law, and Politics</p>
<p class="verse2"><em class="i">David M. Smolin and Kar Yong Lim</em></p>
<p class="firstverse"><span href="#/Text/Chapter9" title="Link target outside of Sample">9: Expectation and Consummation</span></p>
<p class="verse2">Law in Eschatological Perspective</p>
<p class="verse2"><em class="i">John Copeland Nagle and Keith A. Mathison</em></p>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstverse"><span href="#/Text/ListofContributors" title="Link target outside of Sample">List of Contributors</span></p>
<p class="firstverse"><span href="#/Text/GeneralIndex" title="Link target outside of Sample">General Index</span></p>
<p class="firstverse"><span href="#/Text/ScriptureIndex" title="Link target outside of Sample">Scripture Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?760a2182